import { useToast } from "vue-toastification";

export const errorHandlingMixin = {
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    handleError(error, defaultMessage = 'An error occurred') {
      // Log the full error object for debugging
      console.error('Full error object:', error);
      
      let errorMessage = defaultMessage;
      
      try {
        // Check if it's an API error response
        if (error.response?.data) {
          const data = error.response.data;
          errorMessage = data.message || data.error || defaultMessage;
          
          if (data.errors) {
            const errorDetails = Object.entries(data.errors)
              .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
              .join('\n');
            if (errorDetails) {
              errorMessage = errorDetails;
            }
          }
        } 
        // Check if it's a standard Error object
        else if (error instanceof Error) {
          errorMessage = error.message;
        }
        // Check if it's a string
        else if (typeof error === 'string') {
          errorMessage = error;
        }
        // If it's something else, stringify it
        else if (error) {
          errorMessage = JSON.stringify(error);
        }
      } catch (e) {
        console.error('Error in error handling:', e);
        errorMessage = defaultMessage;
      }
      
      // Show error message
      if (this.toast) {
        this.toast.error(errorMessage);
      } else {
        console.error('Toast not available:', errorMessage);
      }
    }
  }
}; 